<template lang="pug">
  uiv-dropdown(:disabled="disabled").form-control-dropdown.form-control-dropdown-key-value
    button(type="button" :disabled="disabled").dropdown-toggle.form-control
      span.dropdown-selected-body {{selectedText}}
    template(v-slot:dropdown)
      li(v-for="(option, key) in options")
        a(role="button" href="#" @click.prevent="onSelectValue(key)") {{option}}
</template>

<script lang="ts">
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
//import * as uiv from 'uiv';

import {Dropdown} from 'uiv';

// Vue.use(uiv, {prefix: 'uiv'})
//
@Component({
  name: 'dropdown-keyvalue',
  components: {
    'uiv-dropdown': Dropdown
  }
})
export default class DropdownKeyValue extends Vue {
  @Prop({ required: true })
  options!: Record<string, string>

  @Prop({ required: true })
  value!: string

  @Prop({ default: 'Выберите' })
  placeholder!: string

  @Prop({default: false})
  disabled: boolean

  @Prop({default: false})
  allowNotFound: boolean

  get isAnySelected() {
    return this.value && this.value in this.options;
  }

  get selectedText() {
    if (!this.value || ( this.value.length == 0))
      return this.placeholderText;
    if (!this.isAnySelected && this.allowNotFound)
      return this.placeholderText;
    return this.value && (this.value && this.options) && this.value in this.options ? this.options[this.value] : this.value;
  }

  get placeholderText(): string {
    return this.$t(this.placeholder) as string;
  }

  onSelectValue(val) {
    this.$emit('input', val);
  }
}
</script>

<style scoped lang="less">
@import "../../../../src/less-mixins/mixins";

.scrollable() {
  /* Let's get this party started */
  &::-webkit-scrollbar {
    width: 8px;
  }

  /* Track */
  &::-webkit-scrollbar-track {
    .border-radius(4px);
    background: #d5e3b7;
  }

  /* Handle */
  &::-webkit-scrollbar-thumb {
    .border-radius(4px);
    background: #80bd1c;
  }
  &::-webkit-scrollbar-thumb:window-inactive {
    background: #a4d74a;
  }
}


.form-control-dropdown::v-deep {
  display: block;

  .dropdown-selected-body {
    overflow: hidden;
    white-space: nowrap;
    margin-right: 20px;
    display: block;
  }

  .dropdown-toggle {
    text-align: left;

    &:after {
      content: "";
      display: block;
      width: 0;
      height: 0;
      border-style: solid;
      border-width: 5px 5px 0 5px;
      border-color: #333 transparent transparent transparent;
      position: absolute;
      right: 15px;
      top: 50%;
      -webkit-transform: translateY(-50%);
      transform: translateY(-50%);
    }

    font-weight: 300;
    font-family: 'Proxima Nova Lt', sans-serif;
    position: relative;
    -webkit-box-shadow: inset 0px 2px 3px 0px rgba(0, 0, 0, 0.1);
    box-shadow: inset 0px 2px 3px 0px rgba(0, 0, 0, 0.1);
    border: none;
    line-height: 30px;
    padding: 1px 15px 0;
    height: 48px;

    &:focus {
      border-color: #66afe9;
      outline: 0;
      -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075), 0 0 8px rgba(102, 175, 233, 0.6);
      box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075), 0 0 8px rgba(102, 175, 233, 0.6);
    }
  }

  .dropdown-menu {
    padding: 10px 5px;
    max-height: 250px;
    overflow-y: auto;
    .scrollable();

    li {
      padding: 0;
      margin: 0;

      a {
        padding: 5px 15px;
        &:hover {
          background: #80bd1c;
          color: #fff;
        }
      }

      &:hover {
        a {
          font-weight: bolder;
          background: #80bd1c;
          color: #fff;

        }
      }
    }
  }
}
</style>

<i18n>
{
  "en": {
    "Выберите": "Please select",
    "Выберите значение": "Please select"
  }
}
</i18n>
